webpackJsonp([0],{

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLoginRegisterPage_vue__ = __webpack_require__(280);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64797348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLoginRegisterPage_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(106)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLoginRegisterPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64797348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLoginRegisterPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9dffe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9dffe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomStyle',
  mounted: function mounted() {
    var styleTag = document.createElement('style');
    styleTag.textContent = this.$refs.styles.textContent;
    this.$refs.styles.textContent = null;
    this.$refs.styles.appendChild(styleTag);
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"styles",staticStyle:{"display":"none"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AuthLoginRegisterPage_DynamicForm__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AuthLoginRegisterPage_ConfirmMessage__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AuthLoginRegisterPage_ConfirmMessagePassword__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AuthLoginRegisterPage_ConfirmMessageChangePassword__ = __webpack_require__(322);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthLoginRegisterPage',
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  components: {
    DynamicForm: __WEBPACK_IMPORTED_MODULE_1__components_AuthLoginRegisterPage_DynamicForm__["a" /* default */],
    ConfirmMessage: __WEBPACK_IMPORTED_MODULE_2__components_AuthLoginRegisterPage_ConfirmMessage__["a" /* default */],
    ConfirmMessagePassword: __WEBPACK_IMPORTED_MODULE_3__components_AuthLoginRegisterPage_ConfirmMessagePassword__["a" /* default */],
    ConfirmMessageChangePassword: __WEBPACK_IMPORTED_MODULE_4__components_AuthLoginRegisterPage_ConfirmMessageChangePassword__["a" /* default */]
  },
  computed: {
    form: function form() {
      return this.$store.getters['authServicesPoints/form'];
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_FormService__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Helpers_ShFormGenerator__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_CustomStyle__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_CancelButton__ = __webpack_require__(309);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DynamicForm',

  components: { CancelButton: __WEBPACK_IMPORTED_MODULE_4__components_Common_CancelButton__["a" /* default */], CustomStyle: __WEBPACK_IMPORTED_MODULE_3__components_Common_CustomStyle__["a" /* default */], ShFormGenerator: __WEBPACK_IMPORTED_MODULE_2__components_Helpers_ShFormGenerator__["a" /* default */] },

  props: {
    formType: {
      type: String,
      default: 'login'
    },
    params: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      formElements: __WEBPACK_IMPORTED_MODULE_1__services_FormService__["a" /* default */].generateFormObject(this.params),
      form: {},
      formParams: {},
      isResendVerificationCodeVisible: false,
      timeAfterShowResendVerisiciationCode: 60000,
      veryficationCodeResendState: 'send',
      veryficationResendCodeTexts: {
        send: 'wyślij ponownie kod weryfikacyjny',
        resend: 'kod weryfikacyjny wysłany ponownie'
      },
      formsDetails: {
        login: {
          title: 'Zaloguj się do swojego konta',
          submitButtonText: 'Zaloguj',
          actionType: 'loginToASP'
        },
        registration: {
          title: 'Załóż nowe konto',
          submitButtonText: 'Załóż konto',
          actionType: 'registerToASP'
        },
        change_password: {
          title: 'Pomoc w odzyskiwaniu hasła',
          description: 'Wpisz swój adres e-mail, aby odzyskać hasło. <br>Otrzymasz wiadomość e-mail z instrukcjami. Jeśli masz problemy z odzyskaniem hasła skontaktuj się z nami.',
          submitButtonText: 'Potwierdź adres',
          actionType: 'changePasswordToASP'
        },
        confirm_change_password: {
          title: 'Podaj hasło',
          submitButtonText: 'Zmień hasło',
          actionType: 'confirmChangePasswordToASP'
        },
        verification: {
          title: 'Załóż nowe konto',
          submitButtonText: 'Weryfikuj',
          actionType: 'registerToASP'
        }
      }
    };
  },
  created: function created() {
    this.updateFormsDetails();
  },


  computed: {
    additionalHtml: function additionalHtml() {
      var _this = this;

      var currentForm = this.formsCustomDetails.find(function (form) {
        return form.name === _this.formType;
      });
      if (!currentForm) return '';

      return currentForm.under_form_html || '';
    },
    formsCustomDetails: function formsCustomDetails() {
      return this.$store.getters['global/forms'];
    },
    fromCustomStyle: function fromCustomStyle() {
      return this.$store.getters['global/brandTheme'].form;
    },
    additionalStyles: function additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    },
    registrationAdditionalData: function registrationAdditionalData() {
      return this.$store.getters['global/brandRegistrationAdditionalData'];
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (this.formType === 'registration') {
      this.formElements = this.formElements.map(function (item) {
        if (item.key === 'terms') {
          item.label = _this2.registrationAdditionalData;
        }
        return item;
      });
    }
  },


  methods: {
    updateFormsDetails: function updateFormsDetails() {
      var _this3 = this;

      var formTypes = ['login', 'registration', 'change_password', 'confirm_change_password', 'verification'];

      formTypes.forEach(function (formType) {
        var currentForm = _this3.formsCustomDetails.find(function (form) {
          return form.name === formType;
        });
        if (currentForm) {
          _this3.formsDetails[formType].title = currentForm.title || _this3.formsDetails[formType].title;
          _this3.formsDetails[formType].submitButtonText = currentForm.submit_button_text || _this3.formsDetails[formType].submitButtonText;
        }
      });

      this.formElements.forEach(function (element, index) {
        var currentForm = _this3.formsCustomDetails.find(function (form) {
          return form.name === _this3.formType;
        });
        if (currentForm && currentForm.fields) {
          var newField = currentForm.fields.find(function (field) {
            return field.key === element.key;
          });
          if (!newField) return;

          if (_this3.formElements[index].label) _this3.formElements[index].label = newField.label || _this3.formElements[index].label;
          if (_this3.formElements[index].placeholder) _this3.formElements[index].placeholder = newField.placeholder || _this3.formElements[index].placeholder;
          if (_this3.formElements[index].prepend) _this3.formElements[index].prepend = newField.prepend || _this3.formElements[index].prepend;
        }
      });
    },
    handleCancelButton: function handleCancelButton() {
      this.formElements = __WEBPACK_IMPORTED_MODULE_1__services_FormService__["a" /* default */].generateFormObject(this.params);
      this.$store.dispatch('authServicesPoints/changeFormState', 'login');
    },
    handleRemindPasswordSubmit: function handleRemindPasswordSubmit() {
      this.formElements = __WEBPACK_IMPORTED_MODULE_1__services_FormService__["a" /* default */].generateFormObject(['email']);
      this.$store.dispatch('authServicesPoints/changeFormState', 'change_password');
    },
    handleSubmit: function handleSubmit(params) {
      var token = __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__["a" /* default */].getTokenFromStorage();
      var gateway = this.$store.getters['authServicesPoints/gateway'];
      var actionType = this.formsDetails[this.formType].actionType;

      if (this.formType !== 'verification' && params.phone_number !== undefined) {
        this.$store.dispatch('authServicesPoints/sendVerificationCode', { params: params, token: token, gateway: gateway });

        var _FormService$transfor = __WEBPACK_IMPORTED_MODULE_1__services_FormService__["a" /* default */].transformToVerificationCode(params, this.formElements),
            model = _FormService$transfor.model,
            newForm = _FormService$transfor.newForm;

        this.form = model;
        this.formParams = params;
        this.formElements = newForm;
        this.updateFormsDetails();
        this.__showResendVerificationCode();
        // eslint-disable-next-line no-useless-return
        return;
      }

      this.$store.dispatch('authServicesPoints/' + actionType, { params: params, token: token, gateway: gateway });
    },
    handleResendCode: function handleResendCode() {
      if (this.veryficationCodeResendState !== 'send') {
        return false;
      }
      var token = __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__["a" /* default */].getTokenFromStorage();
      var gateway = this.$store.getters['authServicesPoints/gateway'];
      this.$store.dispatch('authServicesPoints/resendVerificationCode', {
        params: this.formParams, token: token, gateway: gateway
      });
      this.veryficationCodeResendState = 'resend';
      this.__showResendVerificationCode();
      return true;
    },
    __showResendVerificationCode: function __showResendVerificationCode() {
      var _this4 = this;

      setTimeout(function () {
        _this4.isResendVerificationCodeVisible = true;
        _this4.veryficationCodeResendState = 'send';
      }, this.timeAfterShowResendVerisiciationCode);
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShFormGenerator',
  props: {
    inputsElements: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hideSubmitButton: {
      type: Boolean,
      required: false
    },
    inline: {
      type: Boolean,
      required: false
    },
    cancelButtonClick: {
      type: Boolean,
      default: false
    },
    cancelButtonRedirectLink: {
      type: String
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    uploadText: {
      type: String,
      default: 'Upuść plik tutaj lub kliknij, aby przesłać'
    },
    submitButtonText: {
      type: String
    },
    cancelButtonText: {
      type: String
    },
    loadingText: {
      type: String,
      default: 'Loading data'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    messagesAfterSubmit: {
      type: Object,
      action: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      }
    }
  },
  data: function data() {
    return {
      hash: 0,
      formsData: this.convertDataColumnsToSearchObject(),
      passwordTypeInput: 'password',
      rules: {}
    };
  },

  computed: {
    formInputs: function formInputs() {
      var _this = this;

      this.inputsElements.forEach(function (input) {
        _this.formsData[input.key] = input.type === 'switch' ? false : _this.model ? _this.model[input.key] : '';
        _this.formsData[input.key] = input.type === 'checkbox' ? [] : _this.model[input.key];
        _this.formsData[input.key] = input.type === 'checkbox_one' ? _this.model[input.key] : _this.model[input.key];
      });
      return this.formsData;
    },
    formRules: function formRules() {
      var _this2 = this;

      this.inputsElements.forEach(function (input) {
        var validators = [];

        input.rules.forEach(function (rule) {
          if (rule.validator) {
            validators.push(rule);
          }
        });
        var inputCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(input));
        inputCopy.rules = inputCopy.rules.map(function (rule) {
          var ruleCopy = rule;
          ruleCopy.message = ruleCopy.message;
          return ruleCopy;
        });

        inputCopy.rules = inputCopy.rules.concat(validators);
        _this2.rules[input.key] = inputCopy.rules;
      });

      return this.rules;
    },
    getPasswordTypeInputIcon: function getPasswordTypeInputIcon() {
      return this.passwordTypeInput === 'password' ? 'eye-slash' : 'eye';
    }
  },
  methods: {
    convertDataColumnsToSearchObject: function convertDataColumnsToSearchObject() {
      if (this.inputsElements.length === 0) {
        return {};
      }
      var formsData = {};
      this.inputsElements.forEach(function (field) {
        formsData[field.key] = field.type === 'select' || field.type === 'checkbox' ? [] : '';
      });
      return formsData;
    },
    unLiveComponent: function unLiveComponent() {
      this.hash += 1;
    },
    changeCheckboxState: function changeCheckboxState(field) {
      if (field === 'terms' && !this.formsData[field]) {
        this.$refs.termsField[0].resetField();
        this.$refs.ruleForm.validate();
      }
    },
    remindPassword: function remindPassword(e) {
      e.preventDefault();
      this.$emit('remindPassword', {});
    },
    addFocusedClass: function addFocusedClass(e) {
      e.target.closest('.el-form-item').classList.add('focused');
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (!valid) {
          return false;
        }
        var params = {};
        _this3.inputsElements.forEach(function (field) {
          params[field.key] = field.type === 'checkbox' ? _this3.formsData[field.key][0] : _this3.formsData[field.key];
        });
        _this3.$emit('submit', params);
        return true;
      });
    },
    resetForm: function resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$emit('handleResetForms');
    },
    tooglePasswordTypeInput: function tooglePasswordTypeInput() {
      this.passwordTypeInput = this.passwordTypeInput === 'password' ? 'text' : 'password';
    },
    uploadFile: function uploadFile(field, file) {
      var _this4 = this;

      var reader = new FileReader();
      reader.addEventListener('load', function () {
        _this4.formsData[field.key] = reader.result;
      });
      reader.readAsDataURL(file.raw);
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__ = __webpack_require__(107);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CancelButton',

  props: {
    isNotRedirect: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleCancelEvent: function handleCancelEvent() {
      __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__["a" /* default */].removeTokenFromStorage();
      var platformUrl = this.$store.getters['authServicesPoints/platformUrl'];
      window.location.href = platformUrl;
    },
    handleCancelClick: function handleCancelClick() {
      console.log('sdfsdf');
      this.$emit('handleCancelButton');
    }
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__ = __webpack_require__(274);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmMessage',

  components: { CustomStyle: __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__["a" /* default */] },

  props: [],

  data: function data() {
    return {};
  },


  computed: {
    additionalStyles: function additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    }
  },

  methods: {}
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Common_CustomStyle__ = __webpack_require__(274);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmMessagePassword',

  components: { CustomStyle: __WEBPACK_IMPORTED_MODULE_1__components_Common_CustomStyle__["a" /* default */] },

  props: [],

  data: function data() {
    return {};
  },


  computed: {
    additionalStyles: function additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    }
  },

  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      return _this.handleRedirectToPlatform();
    }, 3000);
  },


  methods: {
    handleRedirectToPlatform: function handleRedirectToPlatform() {
      __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__["a" /* default */].removeTokenFromStorage();
      var platformUrl = this.$store.getters['authServicesPoints/platformUrl'];
      window.location.href = platformUrl;
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__ = __webpack_require__(274);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmMessageChangePassword',

  components: { CustomStyle: __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__["a" /* default */] },

  props: [],

  data: function data() {
    return {};
  },


  computed: {
    additionalStyles: function additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    }
  },

  methods: {}
});

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(302);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("12e0dcc4", content, true, {});

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.AuthLoginRegisterPageView{margin-bottom:100px}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/views/AuthLoginRegisterPage.vue"],"names":[],"mappings":"AACA,2BACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mBACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,2BACE,mBAAqB,CACtB","file":"AuthLoginRegisterPage.vue","sourcesContent":["\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.AuthLoginRegisterPageView {\n  margin-bottom: 100px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a939e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31a939e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a939e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("903440bc", content, true, {});

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-31a939e4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-31a939e4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.DynamicForm[data-v-31a939e4]{width:100%}.DynamicForm__title[data-v-31a939e4]{font-size:28px;font-weight:200;text-align:center}@media screen and (max-width:768px){.DynamicForm__title[data-v-31a939e4]{font-size:16px;font-weight:500}}.DynamicForm__description[data-v-31a939e4]{font-size:14px;text-align:center;line-height:150%;margin-bottom:20px}.DynamicForm__additional-data[data-v-31a939e4]{margin-top:-10px;text-align:center}.DynamicForm[data-v-31a939e4] .el-form-item__error{margin-top:0}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/AuthLoginRegisterPage/DynamicForm/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,8BACE,UAAY,CACb,AACD,qCACI,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACA,qCACQ,eAAgB,AAChB,eAAiB,CACxB,CACA,AACD,2CACI,eAAgB,AAChB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,+CACI,iBAAkB,AAClB,iBAAmB,CACtB,AACD,mDACI,YAAc,CACjB","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-31a939e4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-31a939e4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.DynamicForm[data-v-31a939e4] {\n  width: 100%;\n}\n.DynamicForm__title[data-v-31a939e4] {\n    font-size: 28px;\n    font-weight: 200;\n    text-align: center;\n}\n@media screen and (max-width: 768px) {\n.DynamicForm__title[data-v-31a939e4] {\n        font-size: 16px;\n        font-weight: 500;\n}\n}\n.DynamicForm__description[data-v-31a939e4] {\n    font-size: 14px;\n    text-align: center;\n    line-height: 150%;\n    margin-bottom: 20px;\n}\n.DynamicForm__additional-data[data-v-31a939e4] {\n    margin-top: -10px;\n    text-align: center;\n}\n.DynamicForm[data-v-31a939e4] .el-form-item__error {\n    margin-top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(109);





var formFields = {
  terms: {
    key: 'terms',
    type: 'checkbox_one',
    label: '',
    allowHtml: true,
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'change' }]
  },
  login: {
    key: 'login',
    type: 'text',
    label: 'Login',
    placeholder: 'Login',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }]
  },
  reminder_password: {
    key: 'reminder_password',
    type: 'reminder_password',
    label: 'Nie pamiętasz hasła?',
    placeholder: 'Login',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: []
  },
  change_password: {
    key: 'change_password',
    type: 'change_password',
    label: 'Powtórz hasło',
    placeholder: 'Potwierdź hasło na które chcesz zmienić.',
    prepend: '<i class="fa fa-unlock-alt" aria-hidden="true"></i>',
    rules: []
  },
  password: {
    key: 'password',
    type: 'password',
    label: 'Hasło',
    placeholder: 'Min. 8 znaków, jedna cyfra, jedna wielka litera',
    prepend: '<i class="fa fa-unlock-alt" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }, { min: 8, message: 'Hasło musi posiadać minimalnie 8 znaków.', trigger: 'change' }, { validator: function validator(rule, value, callback) {
        if (!/[A-Z]/.test(value)) {
          callback(new Error('Hasło musi zawierać co najmniej jedną wielką literę'));
        }
        if (!/\d/.test(value)) {
          callback(new Error('Hasło musi zawierać co najmniej jedną cyfrę'));
        }
        callback();
      }
    }]
  },
  email: {
    key: 'email',
    type: 'text',
    label: 'E-mail',
    placeholder: 'Adres email',
    prepend: '<i class="fa fa-envelope" aria-hidden="true"></i>',
    rules: [{ type: 'email', required: true, message: 'Nieprawidłowy adres email.', trigger: 'blur' }]
  },
  name: {
    key: 'name',
    type: 'text',
    label: 'Imię',
    placeholder: 'Imię',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }]
  },
  last_name: {
    key: 'last_name',
    type: 'text',
    label: 'Nazwisko',
    placeholder: 'Nazwisko',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }]
  },
  phone_number: {
    key: 'phone_number',
    type: 'text',
    label: 'Numer telefonu',
    placeholder: 'Numer telefonu',
    prepend: '<i class="fa fa-phone-square" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }, { min: 9, max: 9, message: 'Numer musi zawierać dokładnie 9 znaków.', trigger: 'change' }, { validator: function validator(rule, value, callback) {
        if (!/^\d+$/.test(value)) {
          callback(new Error('Nieprawidłowy numer'));
        }
        callback();
      },
      trigger: 'blur'
    }]
  },
  code: {
    key: 'code',
    type: 'text',
    label: 'Kod',
    placeholder: 'Wpisz otrzymany kod',
    prepend: '<i class="fa fa-phone-square" aria-hidden="true"></i>',
    rules: [{ required: true, message: 'Pole jest wymagane.', trigger: 'blur' }]
  },
  label: {
    key: 'label',
    type: 'label',
    label: 'Na podany w formularzu numer telefonu został wysłany kod SMS',
    placeholder: '',
    prepend: '',
    rules: []
  }
};

var FormService = function () {
  function FormService() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FormService);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FormService, null, [{
    key: 'generateFormObject',
    value: function generateFormObject(params) {
      var _params = params;
      return _params.map(function (field) {
        return formFields[field];
      });
    }
  }, {
    key: 'transformToVerificationCode',
    value: function transformToVerificationCode(params, oldForm) {
      var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["a" /* hDeepCopy */])(params), { code: null });
      var newForm = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["a" /* hDeepCopy */])(oldForm);

      newForm.forEach(function (element) {
        element.disabled = true;
      });
      newForm.push(formFields.label);
      newForm.push(formFields.code);

      return { model: model, newForm: newForm };
    }
  }]);

  return FormService;
}();



/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f75f7ee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(308);
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f75f7ee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.messagesAfterSubmit)?_c('el-alert',{attrs:{"title":_vm.messagesAfterSubmit.title,"type":_vm.messagesAfterSubmit.action,"description":_vm.messagesAfterSubmit.description,"show-icon":""}}):_vm._e(),_vm._v(" "),_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],ref:"ruleForm",attrs:{"hash":_vm.hash,"name":"form","inline":_vm.inline,"element-loading-text":_vm.loadingText,"label-position":_vm.inline? 'left' : _vm.labelPosition,"model":_vm.formsData,"rules":_vm.formRules,"label-width":"160px"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm($event)}}},[_vm._l((_vm.inputsElements),function(input){return _c('el-form-item',{key:input.key,ref:((input.key) + "Field"),refInFor:true,class:("ShFormGenerator__element-" + (input.key) + " " + (input.type === 'checkbox'? 'ShFormGenerator__element-checkbox' : '') + " " + (_vm.formsData[input.key] && _vm.formsData[input.key].length > 0 ? 'focused' : '')),style:(("margin-bottom:" + (input.rules.length === 0? 0 : 10) + "px !important")),attrs:{"label":input.type === 'checkbox' || input.key === 'reminder_password' ? '' : input.label,"prop":input.key,"id":("js-form-element-" + (input.key)),"rules":input.type === 'change_password'? [
        { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
        { validator: function (rule, value, callback) {
          if(_vm.formsData['password'] !== value) {
            callback('Hasło nie są takie same.');
          } else {
            callback();
          }
        },
        } ] : input.rules}},[(input.type === 'label')?[_c('div',{class:("ShFormGenerator__element-" + (input.key) + " ShFormGenerator__label")},[_vm._v("\n          "+_vm._s(input.label)+"\n        ")])]:_vm._e(),_vm._v(" "),(input.type === 'image')?_c('el-upload',{staticClass:"ShFormGenerator__upload",attrs:{"drag":"","action":"","http-request":function () {},"on-change":_vm.uploadFile.bind(null, input),"show-file-list":false}},[(_vm.formsData[input.key])?_c('div',[_c('img',{staticClass:"image-responsive",attrs:{"src":_vm.formsData[input.key]}})]):_vm._e(),_vm._v(" "),(!_vm.formsData[input.key])?_c('div',[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v(_vm._s(_vm.uploadText))])]):_vm._e()]):_vm._e(),_vm._v(" "),(input.type === 'text')?_c('el-input',{class:input.additionalClasses,attrs:{"placeholder":input.placeholder? input.placeholder : '',"disabled":input.disabled},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},[(input.prepend)?_c('template',{slot:"prepend"},[_c('span',{domProps:{"innerHTML":_vm._s(input.prepend)}})]):_vm._e(),_vm._v(" "),(input.append)?_c('template',{slot:"append"},[_c('span',{domProps:{"innerHTML":_vm._s(input.append)}})]):_vm._e()],2):_vm._e(),_vm._v(" "),(input.type === 'number')?_c('el-input-number',{class:input.additionalClasses,attrs:{"min":0,"placeholder":input.placeholder? input.placeholder : '',"disabled":input.disabled},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}}):_vm._e(),_vm._v(" "),(input.type === 'password')?_c('el-input',{class:input.additionalClasses,attrs:{"type":_vm.passwordTypeInput,"placeholder":input.placeholder? input.placeholder : '',"disabled":input.disabled},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},[(input.prepend)?_c('template',{slot:"prepend"},[_c('span',{domProps:{"innerHTML":_vm._s(input.prepend)}})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"slot":"append","id":("js-form-element-password-button-" + (input.key))},on:{"click":_vm.tooglePasswordTypeInput},slot:"append"},[_c('i',{class:("fa fa-" + _vm.getPasswordTypeInputIcon)})])],2):_vm._e(),_vm._v(" "),(input.type === 'change_password')?_c('el-input',{class:input.additionalClasses,attrs:{"type":_vm.passwordTypeInput,"placeholder":input.placeholder? input.placeholder : '',"disabled":input.disabled},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},[(input.prepend)?_c('template',{slot:"prepend"},[_c('span',{domProps:{"innerHTML":_vm._s(input.prepend)}})]):_vm._e()],2):_vm._e(),_vm._v(" "),(input.type === 'reminder_password')?_c('div',{staticClass:"ShFormGenerator__link-reminder"},[_c('a',{attrs:{"href":"/przypomnienie-hasla"},on:{"click":_vm.remindPassword}},[_vm._v("\n          "+_vm._s(input.label)+"\n        ")])]):_vm._e(),_vm._v(" "),(input.type === 'select')?_c('el-select',{class:input.additionalClasses,attrs:{"multiple":input.multiple? true : false,"placeholder":input.placeholder? input.placeholder : '',"disabled":input.disabled},on:{"change":_vm.unLiveComponent},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},_vm._l(((input.options? input.options : [])),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})})):_vm._e(),_vm._v(" "),(input.type === 'switch')?_c('el-switch',{class:input.additionalClasses,attrs:{"disabled":input.disabled},on:{"change":_vm.unLiveComponent},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}}):_vm._e(),_vm._v(" "),(input.type === 'checkbox')?_c('el-checkbox-group',{class:input.additionalClasses,model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},[_c('el-checkbox',{attrs:{"label":input.allowHtml? null : (input.label? input.label : ''),"name":input.key},on:{"change":_vm.unLiveComponent}},[(input.allowHtml)?_c('label',{domProps:{"innerHTML":_vm._s(input.label? input.label : '')}}):_vm._e()])],1):_vm._e(),_vm._v(" "),(input.type === 'checkbox_one')?_c('el-checkbox',{attrs:{"name":input.key,"label":input.allowHtml? null : (input.label? input.label : '')},on:{"change":function () { return _vm.changeCheckboxState(input.key); }},model:{value:(_vm.formsData[input.key]),callback:function ($$v) {_vm.$set(_vm.formsData, input.key, $$v)},expression:"formsData[input.key]"}},[(input.allowHtml)?_c('label',{domProps:{"innerHTML":_vm._s(input.label? input.label : '')}}):_vm._e()]):_vm._e(),_vm._v(" "),(input.extra)?_c('div',{staticClass:"ShFormGenerator-extra"},[_vm._v(_vm._s(input.extra))]):_vm._e()],2)}),_vm._v(" "),_c('el-form-item',{staticClass:"ShFormGenerator-buttons",style:(("margin-bottom:" + (_vm.inline? 0 : 10) + "px !important"))},[(!_vm.cancelButtonClick)?_c('div',[(_vm.cancelButtonRedirectLink)?_c('router-link',{attrs:{"id":"js-form-generator-button__cancel","to":_vm.cancelButtonRedirectLink}},[_c('el-button',{attrs:{"size":"mini","type":"text"}},[_vm._v("\n            "+_vm._s(_vm.cancelButtonText? _vm.cancelButtonText : 'Anuluj')+"\n          ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.cancelButtonClick)?_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.$emit('handleCancelButton')}}},[_vm._v("\n        "+_vm._s(_vm.cancelButtonText? _vm.cancelButtonText : 'Anuluj')+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.hideSubmitButton)?_c('el-button',{attrs:{"type":"primary","id":"js-form-generator-button__submit"},on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._v("\n        "+_vm._s(_vm.submitButtonText? _vm.submitButtonText : 'Zapisz')+"\n      ")]):_vm._e(),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._t("ShFormGenerator-submit")],2)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdaea42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bdaea42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdaea42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(311);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("c0ef1b5a", content, true, {});

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-4bdaea42{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-4bdaea42{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.CancelButton[data-v-4bdaea42]{width:100%;height:45px;font-size:16px;background:none;line-height:20px;text-align:center;border-radius:50px;text-transform:uppercase;-webkit-transition:background-color .2s cubic-bezier(.645,.045,.355,1);transition:background-color .2s cubic-bezier(.645,.045,.355,1)}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/Common/CancelButton/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,+BACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,uEAA+E,AAC/E,8DAAuE,CACxE","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-4bdaea42 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-4bdaea42 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.CancelButton[data-v-4bdaea42] {\n  width: 100%;\n  height: 45px;\n  font-size: 16px;\n  background: none;\n  line-height: 20px;\n  text-align: center;\n  border-radius: 50px;\n  text-transform: uppercase;\n  -webkit-transition: background-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"CancelButton",attrs:{"type":"warning"},on:{"click":function () { return !_vm.isNotRedirect? _vm.handleCancelEvent() : _vm.handleCancelClick(); }}},[_vm._v("\n  Anuluj\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DynamicForm",class:("DynamicForm--" + _vm.formType)},[_c('CustomStyle',[_vm._v("\n    "+_vm._s(_vm.fromCustomStyle)+"\n    "+_vm._s(_vm.additionalStyles)+"\n  ")]),_vm._v(" "),_c('h2',{staticClass:"DynamicForm__title",domProps:{"innerHTML":_vm._s(_vm.formsDetails[_vm.formType].title)}}),_vm._v(" "),(_vm.formsDetails[_vm.formType].description)?_c('div',{staticClass:"DynamicForm__description",domProps:{"innerHTML":_vm._s(_vm.formsDetails[_vm.formType].description)}}):_vm._e(),_vm._v(" "),_c('ShFormGenerator',{attrs:{"inputs-elements":_vm.formElements,"submit-button-text":_vm.formsDetails[_vm.formType].submitButtonText,"model":_vm.form,"className":"ShLoginForm"},on:{"submit":_vm.handleSubmit,"remindPassword":_vm.handleRemindPasswordSubmit}}),_vm._v(" "),_c('CancelButton',{attrs:{"is-not-redirect":_vm.formType === 'change_password'},on:{"handleCancelButton":_vm.handleCancelButton}}),_vm._v(" "),(_vm.formType === 'verification' && _vm.isResendVerificationCodeVisible)?_c('div',{class:{
      'DynamicForm__resend-code': _vm.veryficationCodeResendState === 'send',
      'DynamicForm__resend-code--resned': _vm.veryficationCodeResendState === 'resend'
    },on:{"click":_vm.handleResendCode}},[_vm._v("\n    "+_vm._s(_vm.veryficationResendCodeTexts[_vm.veryficationCodeResendState])+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.additionalHtml)?_c('div',{staticClass:"DynamicForm__additional-html",domProps:{"innerHTML":_vm._s(_vm.additionalHtml)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb1cec28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb1cec28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb1cec28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(316);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("6059ad00", content, true, {});

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-eb1cec28{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-eb1cec28{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ConfirmMessage[data-v-eb1cec28]{width:100%;text-align:center;padding:42px 0 30px}.ConfirmMessage__thanks[data-v-eb1cec28]{font-size:24px;font-weight:800}.ConfirmMessage__info[data-v-eb1cec28]{font-size:14px;font-weight:500;line-height:140%}.ConfirmMessage__info--highlight[data-v-eb1cec28]{text-decoration:underline}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/AuthLoginRegisterPage/ConfirmMessage/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,iCACE,WAAY,AACZ,kBAAmB,AACnB,mBAA2B,CAC5B,AACD,yCACI,eAAgB,AAChB,eAAiB,CACpB,AACD,uCACI,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,kDACM,yBAA2B,CAChC","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-eb1cec28 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-eb1cec28 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.ConfirmMessage[data-v-eb1cec28] {\n  width: 100%;\n  text-align: center;\n  padding: 42px 0px 30px 0px;\n}\n.ConfirmMessage__thanks[data-v-eb1cec28] {\n    font-size: 24px;\n    font-weight: 800;\n}\n.ConfirmMessage__info[data-v-eb1cec28] {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 140%;\n}\n.ConfirmMessage__info--highlight[data-v-eb1cec28] {\n      text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConfirmMessage"},[_c('CustomStyle',[_vm._v("\n    "+_vm._s(_vm.additionalStyles)+"\n  ")]),_vm._v(" "),_c('h1',{staticClass:"ConfirmMessage__thanks"},[_vm._v("Dziękujemy za rejestrację")]),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ConfirmMessage__info"},[_vm._v("\n    Na Twój "),_c('span',{staticClass:"ConfirmMessage__info--highlight"},[_vm._v("adres email")]),_vm._v(" został wysłany link aktywacyjny."),_c('br'),_vm._v("\n    Kliknij go aby potwierdzić swój adres email i "),_c('span',{staticClass:"ConfirmMessage__info--highlight"},[_vm._v("dokończyć aktywację konta")]),_vm._v(".\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589c6fb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(321);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-589c6fb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589c6fb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("b274ef6e", content, true, {});

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-589c6fb4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-589c6fb4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ConfirmMessagePassword[data-v-589c6fb4]{width:100%;text-align:center;padding:42px 0 50px}.ConfirmMessagePassword__thanks[data-v-589c6fb4]{font-size:38px}.ConfirmMessagePassword__info[data-v-589c6fb4]{font-weight:300;line-height:200%}.ConfirmMessagePassword__panel[data-v-589c6fb4]{margin-top:20px}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/AuthLoginRegisterPage/ConfirmMessagePassword/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,yCACE,WAAY,AACZ,kBAAmB,AACnB,mBAA2B,CAC5B,AACD,iDACI,cAAgB,CACnB,AACD,+CACI,gBAAiB,AACjB,gBAAkB,CACrB,AACD,gDACI,eAAiB,CACpB","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-589c6fb4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-589c6fb4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.ConfirmMessagePassword[data-v-589c6fb4] {\n  width: 100%;\n  text-align: center;\n  padding: 42px 0px 50px 0px;\n}\n.ConfirmMessagePassword__thanks[data-v-589c6fb4] {\n    font-size: 38px;\n}\n.ConfirmMessagePassword__info[data-v-589c6fb4] {\n    font-weight: 300;\n    line-height: 200%;\n}\n.ConfirmMessagePassword__panel[data-v-589c6fb4] {\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConfirmMessagePassword"},[_c('CustomStyle',[_vm._v("\n    "+_vm._s(_vm.additionalStyles)+"\n  ")]),_vm._v(" "),_c('h1',{staticClass:"ConfirmMessagePassword__thanks"},[_vm._v("Hasło zostało zmienione")]),_vm._v(" "),_c('p',{staticClass:"ConfirmMessagePassword__info"},[_vm._v("\n    Możesz już się zalogować korzystając z nowego hasła\n  ")]),_vm._v(" "),_c('div',{staticClass:"ConfirmMessagePassword__panel"},[_c('el-button',{staticClass:"ConfirmMessagePassword__button",attrs:{"type":"warning"},on:{"click":_vm.handleRedirectToPlatform}},[_vm._v("\n      Powrót do okna logowania\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162ee640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-162ee640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162ee640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(324);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("19e5a863", content, true, {});

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-162ee640{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-162ee640{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ConfirmMessageChangePassword[data-v-162ee640]{width:100%;text-align:center;padding:42 0 50px}.ConfirmMessageChangePassword__callweb-svg[data-v-162ee640]{display:none}.ConfirmMessageChangePassword__info[data-v-162ee640]{font-size:16px;font-weight:600;line-height:140%;margin:20px 0 50px}.ConfirmMessageChangePassword .instruction__title[data-v-162ee640]{font-size:16px;font-weight:600}.ConfirmMessageChangePassword .instruction__list[data-v-162ee640]{padding:0;list-style-position:inside}.ConfirmMessageChangePassword .instruction__list-item[data-v-162ee640]{font-size:14px;font-weight:500;line-height:17px}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/AuthLoginRegisterPage/ConfirmMessageChangePassword/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,+CACE,WAAY,AACZ,kBAAmB,AACnB,iBAAyB,CAC1B,AACD,4DACI,YAAc,CACjB,AACD,qDACI,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAsB,CACzB,AACD,mEACI,eAAgB,AAChB,eAAiB,CACpB,AACD,kEACI,UAAW,AACX,0BAA4B,CAC/B,AACD,uEACI,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACrB","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-162ee640 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-162ee640 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.ConfirmMessageChangePassword[data-v-162ee640] {\n  width: 100%;\n  text-align: center;\n  padding: 42 0px 50px 0px;\n}\n.ConfirmMessageChangePassword__callweb-svg[data-v-162ee640] {\n    display: none;\n}\n.ConfirmMessageChangePassword__info[data-v-162ee640] {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 140%;\n    margin: 20px 0 50px 0;\n}\n.ConfirmMessageChangePassword .instruction__title[data-v-162ee640] {\n    font-size: 16px;\n    font-weight: 600;\n}\n.ConfirmMessageChangePassword .instruction__list[data-v-162ee640] {\n    padding: 0;\n    list-style-position: inside;\n}\n.ConfirmMessageChangePassword .instruction__list-item[data-v-162ee640] {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 17px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConfirmMessageChangePassword"},[_c('CustomStyle',[_vm._v("\n    "+_vm._s(_vm.additionalStyles)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"ConfirmMessageChangePassword__callweb-svg"},[_c('svg',{attrs:{"width":"214","height":"192","viewBox":"0 0 214 192","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_258_131)"}},[_c('path',{attrs:{"d":"M212.123 73.4238C212.047 73.4234 211.972 73.4013 211.909 73.36L108.077 1.08469C107.762 0.864323 107.387 0.746138 107.002 0.746138C106.617 0.746138 106.242 0.864323 105.926 1.08469L2.84198 73.3563C2.80225 73.3907 2.75572 73.4165 2.7054 73.4318C2.65508 73.4471 2.6021 73.4517 2.54989 73.4453C2.49768 73.4389 2.44741 73.4215 2.40234 73.3944C2.35726 73.3673 2.31839 73.331 2.28824 73.2879C2.25809 73.2449 2.23733 73.1959 2.22732 73.1443C2.21731 73.0927 2.21826 73.0395 2.23012 72.9883C2.24197 72.9371 2.26447 72.8889 2.29614 72.8469C2.32782 72.805 2.36796 72.7701 2.41398 72.7446L105.498 0.473046C105.939 0.166359 106.463 0.00195312 107 0.00195312C107.537 0.00195313 108.061 0.166359 108.502 0.473046L212.333 72.7446C212.398 72.7903 212.448 72.8556 212.473 72.9311C212.499 73.0066 212.5 73.0883 212.476 73.1645C212.452 73.2406 212.405 73.3072 212.341 73.3545C212.276 73.4018 212.199 73.4274 212.119 73.4276L212.123 73.4238Z","fill":"#3F3D56"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.73267 75.9865L107.105 3.12207L206.221 81.1724L112.174 136.896L61.1139 125.263L8.73267 75.9865Z","fill":"#E6E6E6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.4239 171.313H16.8271C16.2252 171.313 15.648 171.074 15.2223 170.649C14.7967 170.223 14.5576 169.646 14.5576 169.045C14.5576 168.443 14.7967 167.866 15.2223 167.441C15.648 167.015 16.2252 166.776 16.8271 166.776H65.4239C66.0258 166.776 66.6031 167.015 67.0287 167.441C67.4543 167.866 67.6935 168.443 67.6935 169.045C67.6935 169.646 67.4543 170.223 67.0287 170.649C66.6031 171.074 66.0258 171.313 65.4239 171.313Z","fill":"#F6A821"}}),_vm._v(" "),_c('path',{attrs:{"d":"M34.2625 161.557H16.8271C16.2252 161.557 15.648 161.318 15.2223 160.892C14.7967 160.467 14.5576 159.89 14.5576 159.288C14.5576 158.687 14.7967 158.11 15.2223 157.684C15.648 157.259 16.2252 157.02 16.8271 157.02H34.2625C34.8644 157.02 35.4417 157.259 35.8673 157.684C36.2929 158.11 36.532 158.687 36.532 159.288C36.532 159.89 36.2929 160.467 35.8673 160.892C35.4417 161.318 34.8644 161.557 34.2625 161.557Z","fill":"#F6A821"}}),_vm._v(" "),_c('path',{attrs:{"d":"M108.502 116.573C108.132 116.573 107.767 116.501 107.424 116.363L46.7422 91.2028V12.447C46.7422 11.7504 47.0191 11.0823 47.5119 10.5897C48.0048 10.0971 48.6733 9.82031 49.3703 9.82031H165.756C166.453 9.82031 167.122 10.0971 167.615 10.5897C168.107 11.0823 168.384 11.7504 168.384 12.447V91.2478L168.272 91.2966L109.598 116.348C109.251 116.495 108.879 116.572 108.502 116.573Z","fill":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M108.502 116.76C108.108 116.761 107.717 116.685 107.353 116.535L46.5544 91.3262V12.4466C46.5554 11.7005 46.8524 10.9853 47.3803 10.4577C47.9081 9.93014 48.6237 9.63332 49.3702 9.63232H165.756C166.503 9.63332 167.218 9.93014 167.746 10.4577C168.274 10.9853 168.571 11.7005 168.572 12.4466V91.3825L109.669 116.524C109.299 116.678 108.903 116.759 108.502 116.76ZM47.3053 90.8272L107.623 115.841C107.901 115.956 108.199 116.015 108.5 116.015C108.801 116.015 109.099 115.956 109.377 115.841L167.821 90.8834V12.4579C167.82 11.9108 167.602 11.3865 167.215 10.9996C166.828 10.6128 166.304 10.3951 165.756 10.3941H49.3702C48.8229 10.3951 48.2982 10.6128 47.9112 10.9996C47.5242 11.3865 47.3063 11.9108 47.3053 12.4579V90.8272Z","fill":"#3F3D56"}}),_vm._v(" "),_c('path',{attrs:{"d":"M211.372 72.6729H211.297L168.196 91.0597L109.226 116.235C108.996 116.332 108.748 116.382 108.498 116.382C108.248 116.382 108 116.332 107.77 116.235L46.9298 91.0147L2.77074 72.7029L2.70316 72.6729H2.62807C1.93106 72.6729 1.2626 72.9496 0.769744 73.4422C0.276885 73.9348 0 74.6029 0 75.2995L0 189.373C0 190.07 0.276885 190.738 0.769744 191.23C1.2626 191.723 1.93106 192 2.62807 192H211.372C212.069 192 212.737 191.723 213.23 191.23C213.723 190.738 214 190.07 214 189.373V75.2995C214 74.6029 213.723 73.9348 213.23 73.4422C212.737 72.9496 212.069 72.6729 211.372 72.6729ZM213.249 189.373C213.249 189.871 213.051 190.348 212.699 190.7C212.347 191.052 211.87 191.249 211.372 191.249H2.62807C2.13021 191.249 1.65274 191.052 1.30069 190.7C0.948652 190.348 0.750877 189.871 0.750877 189.373V75.2995C0.750526 74.8141 0.93848 74.3473 1.27524 73.9974C1.612 73.6476 2.07134 73.4418 2.55674 73.4233L46.9298 91.8102L107.481 116.921C107.804 117.056 108.151 117.125 108.502 117.125C108.852 117.125 109.199 117.056 109.523 116.921L168.196 91.8815L211.447 73.4233C211.932 73.4427 212.39 73.6489 212.726 73.9987C213.062 74.3485 213.25 74.8147 213.249 75.2995V189.373Z","fill":"#3F3D56"}}),_vm._v(" "),_c('path',{attrs:{"d":"M107.879 94.2418C105.64 94.2453 103.46 93.5209 101.669 92.178L101.556 92.0954L78.1627 74.1926C77.0515 73.373 76.1149 72.3402 75.4075 71.1548C74.7002 69.9693 74.2362 68.6549 74.0427 67.2882C73.8492 65.9216 73.9301 64.5301 74.2807 63.195C74.6313 61.8599 75.2445 60.6081 76.0845 59.5125C76.9245 58.4169 77.9745 57.4996 79.1731 56.8141C80.3718 56.1286 81.6951 55.6887 83.0657 55.52C84.4364 55.3513 85.8269 55.4573 87.1561 55.8317C88.4854 56.2062 89.7266 56.8415 90.8074 57.7007L105.96 69.3145L141.766 22.6381C143.444 20.4527 145.922 19.0228 148.655 18.6625C151.388 18.3023 154.152 19.0412 156.34 20.7169L156.115 21.0171L156.344 20.7207C158.526 22.3981 159.954 24.8714 160.315 27.5989C160.676 30.3264 159.94 33.0858 158.27 35.2725L116.15 90.1854C115.175 91.4511 113.922 92.4755 112.488 93.179C111.054 93.8824 109.476 94.2461 107.879 94.2418Z","fill":"#F6A821"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_258_131"}},[_c('rect',{attrs:{"width":"214","height":"192","fill":"white"}})])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"ConfirmMessageChangePassword__info"},[_vm._v("\n    E-mail z instrukcjami dotyczącymi"),_c('br'),_vm._v(" utworzenia nowego hasła został wysłany.\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConfirmMessageChangePassword__instruction instruction"},[_c('h2',{staticClass:"instruction__title"},[_vm._v("\n      Nie dotarł do Ciebie mail?\n    ")]),_vm._v(" "),_c('ol',{staticClass:"instruction__list"},[_c('li',{staticClass:"instruction__list-item"},[_vm._v("Zajrzyj do folderu ze spamem.")]),_vm._v(" "),_c('li',{staticClass:"instruction__list-item"},[_vm._v("Sprawdź, czy podany adres jest poprawny.")]),_vm._v(" "),_c('li',{staticClass:"instruction__list-item"},[_vm._v("Odczekaj 15 minut i spróbuj ponownie.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AuthLoginRegisterPageView view view--centered"},[(_vm.form.type !== 'confirm' && _vm.form.type !== 'email_change_password' && _vm.form.type !== 'confirm_new_change_password')?_c('DynamicForm',{attrs:{"formType":_vm.form.type,"params":_vm.form.params}}):_vm._e(),_vm._v(" "),(_vm.form.type === 'confirm')?_c('ConfirmMessage'):_vm._e(),_vm._v(" "),(_vm.form.type === 'email_change_password')?_c('ConfirmMessageChangePassword'):_vm._e(),_vm._v(" "),(_vm.form.type === 'confirm_new_change_password')?_c('ConfirmMessagePassword'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.8b3d604118fd2c10edc9.js